import { db } from "@/services/module_api";
import { initHilo, initKeyPair } from "@/app/init";
import { ErrorLogger } from "@/utils/module_api";

let storage_bootstrapped = false;

export async function bootStorage(): Promise<void> {
  if (storage_bootstrapped) return;
  storage_bootstrapped = true;

  try {
    await db.initialize();
    initHilo();
    await initKeyPair();
    console.log("[bootstrap/storage] storage initialized");
  } catch (err) {
    ErrorLogger.logError(err as Error, "storage_bootstrap");
    console.error("[bootstrap/storage] boot failed", err);
    throw err;
  }
}
